import { QuillModules } from 'ngx-quill';

export const quillModules: QuillModules = {
  toolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']],
};
